import React, { useState, useEffect, useMemo } from "react";

import styled from "styled-components";

import { useTranslation } from "react-i18next";

import axios from "util/axios";

import Rows from "./Rows";

const getData = async (setter) => {
    const response = await axios
        .post(process.env.REACT_APP_API + "/batch/getBatch", {})
        .then((Response) => Response.data.data.result);
    setter((D) => response);
};

const Title = styled.div`
    width: 100%;
    height: 60px;
    margin-bottom: 30px;
    > h3 {
        line-height: 60px;
    }
`;


const App = () => {
    const { t } = useTranslation(["page"]);

    const [Data, SetData] = useState([]);

    useEffect(() => {
        getData(SetData);
    }, []);

	const resources = async () => {
		const response = await axios.post(process.env.REACT_APP_API+"/common/resources")
						.then(Response => Response.data.data);
		console.log(response);
	}

    return (
        <div className="bpl-container">
            <section className={"admin_batch"}>
                <Title>
                    <h3 className="list_name">{t("batchManagement")}</h3>
                </Title>

                <div>
                    <table className="bpl-table-default">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Batch name</th>
                                <th>Schedule</th>
                                <th>Active</th>
                                <th>Last Execution</th>
                                <th>Last Execution Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Data.map((rowData, index) => {
                                return <Rows rowData={rowData} index={index} key={rowData.jobName} />;
                            })}
                        </tbody>
                    </table>
                </div>
				
            </section>

        </div>
    );
};

export default App;
